module.exports = __webpack_public_path__ + "img/adele_20s_novembre_2021.66a70442.jpg";